import React from 'react';
import { FadeIn } from './FadeIn';
export function HowItWorks() {
  const steps = [{
    num: '1',
    title: 'Estabilización',
    desc: 'Aplicas el paso 1 para recuperar el sueño y la calma física.'
  }, {
    num: '2',
    title: 'Diagnóstico',
    desc: 'Usas los filtros de los capítulos 3 y 5 para ver la verdad de tu pareja sin filtros.'
  }, {
    num: '3',
    title: 'Decisión',
    desc: 'Ejecutas el plan de acción del capítulo 7 para reconstruir o cerrar la puerta con poder.'
  }];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-brand-dark" data-id="element-71">
      <div className="max-w-4xl mx-auto" data-id="element-72">
        <FadeIn data-id="element-73">
          <h2 className="text-3xl sm:text-4xl font-serif text-brand-amber mb-16 text-center" data-id="element-74">
            Cómo funciona
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-75">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-8 left-[15%] right-[15%] h-[1px] bg-brand-amber/20 z-0" data-id="element-76"></div>

          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} className="relative z-10" data-id="element-77">
              <div className="flex flex-col items-center text-center" data-id="element-78">
                <div className="w-16 h-16 rounded-full bg-brand-dark border-2 border-brand-amber flex items-center justify-center text-2xl font-serif text-brand-amber mb-6 shadow-[0_0_15px_rgba(200,149,108,0.2)]" data-id="element-79">
                  {step.num}
                </div>
                <h3 className="text-xl font-semibold text-brand-offwhite mb-3" data-id="element-80">
                  {step.title}
                </h3>
                <p className="text-brand-offwhite/70 leading-relaxed" data-id="element-81">
                  {step.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}